import "./IconChain.scss";

interface Props {
  size?: "lg" | "small";
}
export const IconChain = ({ size = "lg" }: Props) => {
  return <span className={`icon-chain--${size}`}></span>;
};
